import React, { FC } from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faDesktop } from "@fortawesome/pro-solid-svg-icons/faDesktop";
import { faMobile } from "@fortawesome/pro-solid-svg-icons/faMobile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tag from "antd/es/tag";
import { useIntl } from "react-intl";

import { GuideType } from "@mapmycustomers/shared/enum";

import { getGuideTypeDisplayName } from "@app/util/ui";

const typeToIcon: Readonly<Record<GuideType, IconProp>> = {
  [GuideType.MOBILE]: faMobile,
  [GuideType.WEB]: faDesktop,
};

export interface GuideTypeProps {
  type: GuideType;
}

const GuideTypeTag: FC<GuideTypeProps> = ({ type }) => {
  const intl = useIntl();

  return (
    <Tag>
      <FontAwesomeIcon icon={typeToIcon[type]} /> {getGuideTypeDisplayName(intl, type)}
    </Tag>
  );
};

export default GuideTypeTag;
